import { AuthGuard } from '@repo/user-session';
import { useSetAtom } from 'jotai';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';

import ErrorPageLayout from '@/components/error/ErrorPageLayout';
import { SimpleAuthInputContainer } from '@/components/tax-refund/simple-auth/input/SimpleAuthInputContainer';
import { FROM_TYPE_CONFIG } from '@/lib/constants/simple-auth-from-type';
import { simpleAuthFromTypeAtom } from '@/lib/stores/simple-auth';
import { SimpleAuthFromType } from '@/lib/types/simple-auth';

interface Props {
  from: string;
}

function SimpleAuthInputPage({ from }: Props) {
  const router = useRouter();
  const setSimpleAuthFromType = useSetAtom(simpleAuthFromTypeAtom);
  const isValidFromType = from in FROM_TYPE_CONFIG;

  useIsomorphicLayoutEffect(() => {
    if (isValidFromType) {
      setSimpleAuthFromType(from as SimpleAuthFromType);
    }
  }, [from]);

  if (!isValidFromType) {
    return (
      <ErrorPageLayout
        title={'페이지에 접근할 수 없어요'}
        message={'주소가 잘못 입력되었거나\n페이지 접근 권한이 없어요.'}
        onClick={() => {
          router.back();
        }}
      />
    );
  }
  return <SimpleAuthInputContainer />;
}

SimpleAuthInputPage.getLayout = (page: ReactElement) => <AuthGuard>{page}</AuthGuard>;

export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
  const { from } = context.query;

  const stringQueries = (Array.isArray(from) ? from[0] : from) || '';

  return {
    props: {
      from: stringQueries
    }
  };
};

export default SimpleAuthInputPage;
